import { stringify } from 'querystring';

import { useCallback } from 'react';

import { GoogleTagManager } from '@iwoca/frontend-tracking-library';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { getQueryParams } from '@src/helpers/helpers';
import IwTracking from '@src/tracking/IwTracking';

import { useCurrentStep } from './useCurrentStep';
import {
    convertActiveStepIdToStepPathName,
    convertStepPathNameToActiveStepId,
    PRODUCT_OFFERS_STEP_ID
} from '../containers/Routes/helper/stepActiveIds.helper';

export const useNavigateToStep = () => {
    const navigate = useNavigate();
    const { locale } = useIntl();
    const currentStepPath = useCurrentStep();

    const basePath = locale === 'de' ? '/konto/anmeldung' : '/account/signup';

    const getCurrentStepId = (): string => {
        return convertStepPathNameToActiveStepId(currentStepPath);
    };

    const getPreviousStepId = (
        stepOrder: string[],
        isNewOffersEnabled: boolean
    ): string | null => {
        const currentStepId = getCurrentStepId();
        const finalStepOrder = isNewOffersEnabled
            ? stepOrder
            : stepOrder.filter((page) => page !== PRODUCT_OFFERS_STEP_ID);

        const currentIndex = finalStepOrder.indexOf(currentStepId);
        return currentIndex > 0 ? finalStepOrder[currentIndex - 1] : null;
    };

    const navigateToStep = useCallback(
        (stepId) => {
            const pathname = convertActiveStepIdToStepPathName(
                stepId,
                locale === 'en'
            );
            const params = getQueryParams();
            const queryString = stringify(params);
            const fullPath = `${basePath}/${pathname}${
                queryString ? `?${queryString}` : ''
            }`;

            IwTracking.setLatestActiveSignupStep(stepId);
            GoogleTagManager.viewPage(fullPath);
            navigate(fullPath);
        },
        [navigate, locale, basePath]
    );

    return {
        getPreviousStepId,
        navigateToStep,
        currentStepId: getCurrentStepId()
    };
};
